import { InterruptedSessionIcon } from './interrupted-session-icon';
import { RemoteLiveRunningSessionIcon } from './remote-live-running-session-icon';
import { RemoteOfflineSessionIcon } from './remote-offline-session-icon';

interface RemoteSessionStatusIconProps {
  sessionId: string | null | undefined;
}

/** Yield order: offline/reconnected → BluetoothOff; else live-running; else interrupted. */
export function RemoteSessionStatusIcon({ sessionId }: RemoteSessionStatusIconProps) {
  return (
    <>
      <InterruptedSessionIcon sessionId={sessionId} />
      <RemoteOfflineSessionIcon sessionId={sessionId} />
      <RemoteLiveRunningSessionIcon sessionId={sessionId} />
    </>
  );
}
